import { render, staticRenderFns } from "./posterPayResult.vue?vue&type=template&id=725ba66e&scoped=true&"
import script from "./posterPayResult.vue?vue&type=script&lang=js&"
export * from "./posterPayResult.vue?vue&type=script&lang=js&"
import style0 from "./posterPayResult.vue?vue&type=style&index=0&id=725ba66e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725ba66e",
  null
  
)

export default component.exports